import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';

export default async function deleteTag(
  id = '',
) {
  try {
    const _config = {
      url: `${urlBaseAccreditation}/zebraTagCode/inactiveZebraTagCode`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        id: id,
      }
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return;
  } catch (error) {
    console.log('Error deleteTag', error);
    throw error;
  }
}
